import React from 'react';
import type { RestrictedFieldGroupComponentProps as SidebarRestrictedFieldGroupComponentProps } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types.tsx';
import { RestrictedFieldGroup as SidebarRestrictedFieldGroup } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/ui/sidebar/restricted-field-group/main.tsx';
import { messages } from './messages.tsx';

type Props = SidebarRestrictedFieldGroupComponentProps;

export const RestrictedFieldGroup = (props: Props) => (
	<SidebarRestrictedFieldGroup {...props} restrictedFieldGroupMessages={messages} />
);
